import React from "react";

const Hearts = ({ width, height, color }) => (
  <svg
    fill="none"
    viewBox="0 0 20 20"
    width={width || "20"}
    height={height || "20"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_623_16597)">
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color || "#0E1B1B"}
        d="M12.9547 8.27151C13.2663 7.71785 13.5261 7.21825 13.6864 6.838C14.4645 4.99155 13.6951 2.86763 11.8142 2.00126C9.9333 1.13489 8.04459 2.03324 7.21567 3.76776C5.63055 2.68008 3.51606 2.83982 2.34999 4.53719C1.18391 6.23456 1.54988 8.45202 3.14699 9.66203C3.87183 10.2112 5.30538 11.0205 6.65504 11.7407M13.5811 9.79195C13.2293 7.90199 11.6212 6.51977 9.59645 6.89545C7.57168 7.27113 6.26248 9.09789 6.5362 11.0828C6.75612 12.6776 7.97002 16.4193 8.43875 17.8286C8.50272 18.021 8.5347 18.1171 8.59802 18.1842C8.65318 18.2426 8.72653 18.285 8.8047 18.3035C8.89443 18.3248 8.9937 18.3044 9.19225 18.2637C10.6472 17.9649 14.4945 17.1453 15.9856 16.5384C17.8414 15.783 18.7992 13.7371 18.0818 11.7945C17.3644 9.85188 15.3937 9.15158 13.5811 9.79195Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_623_16597">
        <rect width="20" height="20" fill="transparent" />
      </clipPath>
    </defs>
  </svg>
);

export default Hearts;
